module.exports = __webpack_public_path__ + "img/Warlock-orc-f-70.5c3aac83.gif";